<template>
  <div class="saved-matches-container">
    
    <div class="saved-header">
      <h3 class="saved-title">Saved Matches</h3>
      <span class="clear-all-btn" @click="showClearConfirm = true" title="Удалить все матчи">
        <img :src="removeImg" alt="Очистить всё" />
      </span>
    </div>

    <transition name="fade">
      <div class="confirm-overlay" v-if="showClearConfirm">
        <div class="confirm-box">
          <p class="confirm-text">Удалить ВСЕ сохраненные матчи?</p>
          <div class="confirm-actions">
            <button class="btn-confirm yes" @click="clearAllMatches">Да</button>
            <button class="btn-confirm no" @click="showClearConfirm = false">Нет</button>
          </div>
        </div>
      </div>
    </transition>

    <div class="scroller">
      <div id="accordion">
        
        <div class="card" v-for="(countryObj, cIndex) in groupedMatches" :key="'country-' + cIndex">
          
          <div class="card-header country-header d-flex justify-content-between align-items-center onHover" 
               @click="toggleCountry(cIndex)"
               :style="getFlagStyle(countryObj.country)">
            
            <span class="league-country-title">{{ countryObj.country || 'Unknown' }}</span>
            <span class="arrow-icon" :class="{ 'arrow-up': isCountryOpen(cIndex) }">▼</span>
          </div>
          
          <transition name="fade-slide">
            <div class="collapse-content" v-show="isCountryOpen(cIndex)">
              <div class="league-wrapper" v-for="(league, lIndex) in countryObj.leagues" :key="'league-' + cIndex + '-' + lIndex">
                
                <div class="league-header d-flex justify-content-between align-items-center onHover" @click="toggleLeague(cIndex, lIndex)">
                  <span class="league-name">{{ league.competition }}</span>
                  <span class="arrow-icon" :class="{ 'arrow-up': isLeagueOpen(cIndex, lIndex) }">▼</span>
                </div>
                
                <transition name="fade-slide">
                  <div class="collapse-content" v-show="isLeagueOpen(cIndex, lIndex)">
                    <ul class="list-group">
                      <li class="list-group-item" v-for="(row, mIndex) in league.matches" :key="'match-' + cIndex + '-' + lIndex + '-' + mIndex" @click="getMatch(cIndex, lIndex, mIndex)">
                        <span class="list-group-item-span" :title="matchTitle(row)">
                          {{ row.teamAName }} - {{ row.teamBName }}
                          <span v-if="row.seasonLabel" class="season-tag" :title="row.seasonLabel">{{ row.seasonLabel }}</span>
                       </span>
                        <span class="remove onHover" @click.stop="removeMatch(row)">
                          <img :src="removeImg" alt="Удалить" />
                        </span>
                      </li>
                    </ul>
                  </div>
                </transition>

              </div>
            </div>
          </transition>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import removeImg from "@/assets/img/trash.svg";
import { countriesData } from "@/assets/leaguesData.js";
import axios from "axios";

// =========================================================================
// 🌟 ПАК ФЛАГОВ
// =========================================================================
const customBackgrounds = {
  'albania': '/img/Flags/Albania 1.svg',
  'algeria': '/img/Flags/Algeria 1.svg',
  'andorra': '/img/Flags/Andorra 1.svg',
  'argentina': '/img/Flags/Argentina 1.svg',
  'armenia': '/img/Flags/Armenia 1.svg',
  'australia': '/img/Flags/Australia 1.svg',
  'austria': '/img/Flags/Austria 1.svg',
  'azerbaijan': '/img/Flags/Azerbaijan 1.svg',
  'bangladesh': '/img/Flags/Bangladesh 1.svg',
  'belarus': '/img/Flags/Belarus 1.svg',
  'belgium': '/img/Flags/Belgium 1.svg',
  'bhutan': '/img/Flags/Bhutan 1.svg',
  'bolivia': '/img/Flags/Bolivia 1.svg',
  'bosnia-herzegovina': '/img/Flags/Bosnia and Herzegovina 1.svg',
  'bosnia': '/img/Flags/Bosnia and Herzegovina 1.svg',
  'brazil': '/img/Flags/Brazil 1.svg',
  'bulgaria': '/img/Flags/Bulgaria 1.svg',
  'cambodia': '/img/Flags/Cambodia 1.svg',
  'canada': '/img/Flags/Canada 1.svg',
  'chile': '/img/Flags/Chile 1.svg',
  'china': '/img/Flags/China 1.svg',
  'chinese taipei': '/img/Flags/Taiwan 1.svg',
  'taiwan': '/img/Flags/Taiwan 1.svg',
  'colombia': '/img/Flags/Colombia 1.svg',
  'comoros': '/img/Flags/Comoros 1.svg',
  'costa rica': '/img/Flags/Costa Rica 1.svg',
  'croatia': '/img/Flags/Croatia 1.svg',
  'cyprus': '/img/Flags/Cyprus 1.svg',
  'czech republic': '/img/Flags/Czech Republic 1.svg',
  'czechia': '/img/Flags/Czech Republic 1.svg',
  'denmark': '/img/Flags/Denmark 1.svg',
  'dominican republic': '/img/Flags/Dominican Republic 1.svg',
  'east germany (gdr)': '/img/Flags/Germany 1.svg',
  'ecuador': '/img/Flags/Ecuador 1.svg',
  'egypt': '/img/Flags/Egypt 1.svg',
  'el salvador': '/img/Flags/El Salvador 1.svg',
  'england': '/img/Flags/England 1.svg',
  'estonia': '/img/Flags/Estonia 1.svg',
  'ethiopia': '/img/Flags/Ethiopia 1.svg',
  'faroe islands': '/img/Flags/Faroe Islands 1.svg',
  'fiji': '/img/Flags/Fiji 1.svg',
  'finland': '/img/Flags/Finland 1.svg',
  'france': '/img/Flags/France 1.svg',
  'georgia': '/img/Flags/Georgia 1.svg',
  'germany': '/img/Flags/Germany 1.svg',
  'ghana': '/img/Flags/Ghana 1.svg',
  'gibraltar': '/img/Flags/Gibraltar 1.svg',
  'greece': '/img/Flags/Greece 1.svg',
  'guatemala': '/img/Flags/Guatemala 1.svg',
  'honduras': '/img/Flags/Honduras 1.svg',
  'hongkong': '/img/Flags/Hong Kong 1.svg',
  'hong kong': '/img/Flags/Hong Kong 1.svg',
  'hungary': '/img/Flags/Hungary 1.svg',
  'iceland': '/img/Flags/Iceland 1.svg',
  'india': '/img/Flags/India 1.svg',
  'indonesia': '/img/Flags/Indonesia 1.svg',
  'iran': '/img/Flags/Iran 1.svg',
  'iraq': '/img/Flags/Iraq 1.svg',
  'ireland': '/img/Flags/Ireland 1.svg',
  'israel': '/img/Flags/Israel 1.svg',
  'italy': '/img/Flags/Italy 1.svg',
  'jamaica': '/img/Flags/Jamaica 1.svg',
  'japan': '/img/Flags/Japan 1.svg',
  'jordan': '/img/Flags/Jordan 1.svg',
  'kazakhstan': '/img/Flags/Kazakhstan 1.svg',
  'korea, south': '/img/Flags/South Korea 1.svg',
  'south korea': '/img/Flags/South Korea 1.svg',
  'north korea': '/img/Flags/North Korea 1.svg',
  'kosovo': '/img/Flags/Kosovo 1.svg',
  'kyrgyzstan': '/img/Flags/Kyrgyzstan 1.svg',
  'laos': '/img/Flags/Laos 1.svg',
  'latvia': '/img/Flags/Latvia 1.svg',
  'lebanon': '/img/Flags/Lebanon 1.svg',
  'libya': '/img/Flags/Libya 1.svg',
  'liechtenstein': '/img/Flags/Liechtenstein 1.svg',
  'lithuania': '/img/Flags/Lithuania 1.svg',
  'luxembourg': '/img/Flags/Luxembourg 1.svg',
  'malaysia': '/img/Flags/Malaysia 1.svg',
  'malta': '/img/Flags/Malta 1.svg',
  'mexico': '/img/Flags/Mexico 1.svg',
  'moldova': '/img/Flags/Moldova 1.svg',
  'montenegro': '/img/Flags/Montenegro 1.svg',
  'morocco': '/img/Flags/Morocco 1.svg',
  'myanmar': '/img/Flags/Myanmar 1.svg',
  'nepal': '/img/Flags/Nepal 1.svg',
  'netherlands': '/img/Flags/Netherlands 1.svg',
  'new zealand': '/img/Flags/New Zealand 1.svg',
  'nicaragua': '/img/Flags/Nicaragua 1.svg',
  'nigeria': '/img/Flags/Nigeria 1.svg',
  'north macedonia': '/img/Flags/North Macedonia 1.svg',
  'macedonia': '/img/Flags/North Macedonia 1.svg',
  'northern ireland': '/img/Flags/Northern Ireland 1.svg',
  'norway': '/img/Flags/Norway 1.svg',
  'oman': '/img/Flags/Oman 1.svg',
  'panama': '/img/Flags/Panama 1.svg',
  'paraguay': '/img/Flags/Paraguay 1.svg',
  'peru': '/img/Flags/Peru 1.svg',
  'philippines': '/img/Flags/Philippines 1.svg',
  'pakistan': '/img/Flags/Pakistan 1.svg',
  'poland': '/img/Flags/Poland 1.svg',
  'portugal': '/img/Flags/Portugal 1.svg',
  'puerto rico': '/img/Flags/Puerto Rico 1.svg',
  'qatar': '/img/Flags/Qatar 1.svg',
  'republic of the congo': '/img/Flags/Republic of the Congo 1.svg',
  'congo': '/img/Flags/Republic of the Congo 1.svg',
  'romania': '/img/Flags/Romania 1.svg',
  'russia': '/img/Flags/Russia 1.svg',
  'rwanda': '/img/Flags/Rwanda 1.svg',
  'san marino': '/img/Flags/San Marino 1.svg',
  'saudi arabia': '/img/Flags/Saudi Arabia 1.svg',
  'scotland': '/img/Flags/Scotland 1.svg',
  'senegal': '/img/Flags/Senegal 1.svg',
  'serbia': '/img/Flags/Serbia 1.svg',
  'singapore': '/img/Flags/Singapore 1.svg',
  'slovakia': '/img/Flags/Slovakia 1.svg',
  'slovenia': '/img/Flags/Slovenia 1.svg',
  'south africa': '/img/Flags/South Africa 1.svg',
  'spain': '/img/Flags/Spain 1.svg',
  'sweden': '/img/Flags/Sweden 1.svg',
  'switzerland': '/img/Flags/Switzerland 1.svg',
  'syria': '/img/Flags/Syria 1.svg',
  'tajikistan': '/img/Flags/Tajikistan 1.svg',
  'thailand': '/img/Flags/Thailand 1.svg',
  'tunisia': '/img/Flags/Tunisia 1.svg',
  'türkiye': '/img/Flags/Türkiye 1.svg',
  'turkey': '/img/Flags/Türkiye 1.svg',
  'udssr': '/img/Flags/Russia 1.svg',
  'ussr': '/img/Flags/Russia 1.svg',
  'uganda': '/img/Flags/Uganda 1.svg',
  'ukraine': '/img/Flags/Ukraine 1.svg',
  'united arab emirates': '/img/Flags/United Arab Emirates 1.svg',
  'uae': '/img/Flags/United Arab Emirates 1.svg',
  'united states': '/img/Flags/United States 1.svg',
  'usa': '/img/Flags/United States 1.svg',
  'uruguay': '/img/Flags/Uruguay 1.svg',
  'uzbekistan': '/img/Flags/Uzbekistan 1.svg',
  'venezuela': '/img/Flags/Venezuela 1.svg',
  'vietnam': '/img/Flags/Vietnam 1.svg',
  'wales': '/img/Flags/Wales 1.svg'
};

const leagueIdToCountryMap = {};

if (countriesData && Array.isArray(countriesData)) {
  countriesData.forEach(country => {
    if (country.leagues && Array.isArray(country.leagues)) {
      country.leagues.forEach(league => {
        if (league.id) {
          leagueIdToCountryMap[league.id] = country.name;
        }
      });
    }
  });
}

const fallbackCountryCodes = {
  'albania': 'al', 'algeria': 'dz', 'andorra': 'ad', 'argentina': 'ar', 'armenia': 'am',
  'australia': 'au', 'austria': 'at', 'azerbaijan': 'az', 'bangladesh': 'bd', 'belarus': 'by',
  'belgium': 'be', 'bhutan': 'bt', 'bolivia': 'bo', 'bosnia-herzegovina': 'ba', 'bosnia': 'ba',
  'brazil': 'br', 'bulgaria': 'bg', 'cambodia': 'kh', 'canada': 'ca', 'chile': 'cl',
  'china': 'cn', 'chinese taipei': 'tw', 'taiwan': 'tw', 'colombia': 'co', 'comoros': 'km',
  'costa rica': 'cr', 'croatia': 'hr', 'cyprus': 'cy', 'czech republic': 'cz', 'czechia': 'cz',
  'denmark': 'dk', 'dominican republic': 'do', 'east germany (gdr)': 'de', 'ecuador': 'ec', 'egypt': 'eg',
  'el salvador': 'sv', 'england': 'gb-eng', 'estonia': 'ee', 'ethiopia': 'et', 'faroe islands': 'fo',
  'fiji': 'fj', 'finland': 'fi', 'france': 'fr', 'georgia': 'ge', 'germany': 'de',
  'ghana': 'gh', 'gibraltar': 'gi', 'greece': 'gr', 'guatemala': 'gt', 'honduras': 'hn',
  'hongkong': 'hk', 'hungary': 'hu', 'iceland': 'is', 'india': 'in', 'indonesia': 'id',
  'iran': 'ir', 'iraq': 'iq', 'ireland': 'ie', 'israel': 'il', 'italy': 'it',
  'jamaica': 'jm', 'japan': 'jp', 'jordan': 'jo', 'kazakhstan': 'kz', 'korea, south': 'kr',
  'south korea': 'kr', 'kosovo': 'xk', 'kyrgyzstan': 'kg', 'laos': 'la', 'latvia': 'lv',
  'lebanon': 'lb', 'libya': 'ly', 'liechtenstein': 'li', 'lithuania': 'lt', 'luxembourg': 'lu',
  'malaysia': 'my', 'malta': 'mt', 'mexico': 'mx', 'moldova': 'md', 'montenegro': 'me',
  'morocco': 'ma', 'myanmar': 'mm', 'nepal': 'np', 'netherlands': 'nl', 'new zealand': 'nz',
  'nicaragua': 'ni', 'nigeria': 'ng', 'north macedonia': 'mk', 'macedonia': 'mk', 'northern ireland': 'gb-nir',
  'norway': 'no', 'oman': 'om', 'panama': 'pa', 'paraguay': 'py', 'peru': 'pe',
  'philippines': 'ph', 'poland': 'pl', 'portugal': 'pt', 'puerto rico': 'pr', 'qatar': 'qa',
  'romania': 'ro', 'russia': 'ru', 'san marino': 'sm', 'saudi arabia': 'sa', 'scotland': 'gb-sct',
  'senegal': 'sn', 'serbia': 'rs', 'singapore': 'sg', 'slovakia': 'sk', 'slovenia': 'si',
  'south africa': 'za', 'spain': 'es', 'sweden': 'se', 'switzerland': 'ch', 'syria': 'sy',
  'tajikistan': 'tj', 'thailand': 'th', 'tunisia': 'tn', 'türkiye': 'tr', 'turkey': 'tr',
  'udssr': 'ru', 'ussr': 'ru', 'uganda': 'ug', 'ukraine': 'ua', 'united arab emirates': 'ae', 'uae': 'ae',
  'united states': 'us', 'usa': 'us', 'uruguay': 'uy', 'uzbekistan': 'uz', 'venezuela': 've',
  'vietnam': 'vn', 'wales': 'gb-wls'
};

export default {
  name: "savedMatch",
  data: () => ({ 
    removeImg, 
    openCountries: [], 
    openLeagues: [],
    showClearConfirm: false 
  }),
  methods: {
    getFlagStyle(countryName) {
      if (!countryName) return {};

      const cleanName = countryName.toLowerCase().trim();
      let bgUrl = '';

      if (customBackgrounds[cleanName]) {
        bgUrl = customBackgrounds[cleanName];
      } else if (fallbackCountryCodes[cleanName]) {
        bgUrl = `https://flagcdn.com/w160/${fallbackCountryCodes[cleanName]}.png`;
      }

      if (!bgUrl) return {}; 
      
      return {
        backgroundImage: `url('${bgUrl}')`,
        backgroundPosition: 'right 55px center', 
        backgroundSize: 'auto 130%', 
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#f8f9fa' 
      };
    },

    toggleCountry(cIndex) {
      const pos = this.openCountries.indexOf(cIndex);
      if (pos !== -1) {
        this.openCountries.splice(pos, 1);
      } else {
        this.openCountries.push(cIndex);
      }
    },
    isCountryOpen(cIndex) {
      return this.openCountries.includes(cIndex);
    },

    toggleLeague(cIndex, lIndex) {
      const key = `${cIndex}-${lIndex}`;
      const pos = this.openLeagues.indexOf(key);
      if (pos !== -1) {
        this.openLeagues.splice(pos, 1);
      } else {
        this.openLeagues.push(key);
      }
    },
    isLeagueOpen(cIndex, lIndex) {
      return this.openLeagues.includes(`${cIndex}-${lIndex}`);
    },

    async getMatch(cIndex, lIndex, mIndex) {
      const matchData = this.groupedMatches[cIndex].leagues[lIndex].matches[mIndex];
      
      // 🕵️‍♂️ ВЫВОДИМ В КОНСОЛЬ, ЧТОБЫ УВИДЕТЬ, КАКИЕ ПОЛЯ ЕСТЬ В БАЗЕ
      console.log("⚽ Данные матча из списка:", JSON.parse(JSON.stringify(matchData)));

      // Пробуем все возможные варианты ключа (новый, старый, и стандартный url).
      // savedId/id идут ПЕРВЫМИ: в них есть суффикс сезона, а в matchUrl его нет —
      // иначе два прогона одного матча за разные сезоны ведут на одну и ту же запись.
      const matchIdToLoad = matchData.savedId || matchData.id || matchData.matchUrl || matchData.url;

      // 🛡 ЗАЩИТА: Если ID так и не нашелся, тормозим процесс
      if (!matchIdToLoad) {
          alert("У этого матча нет ID! Скорее всего, он был сохранен до исправления кода. Пожалуйста, удалите его крестиком и спарсите этот кастомный матч заново.");
          return;
      }

      // 🌟 НАШ НОВЫЙ ФИЛЬТР: Отрезаем URL, оставляем только чистый ID
      let cleanId = matchIdToLoad;
      if (typeof cleanId === 'string' && cleanId.includes('/')) {
        const parts = cleanId.split('/');
        cleanId = parts[parts.length - 1].trim(); // Забираем только последние цифры
      }

      document.title = `${matchData.teamAName} - ${matchData.teamBName}`;
      
      try {
        // Вытаскиваем токен прямо из куки браузера надежным способом
        const getCookie = (name) => {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return '';
        };

        // 🚀 Используем cleanId вместо matchIdToLoad
        const response = await axios.get(`/api/localstorage/savedMatches/${cleanId}/details`, {
          headers: {
            Authorization: this.$cookie ? this.$cookie.get('token') : getCookie('token')
          }
        });
        
        const fullMatchDetails = response.data;
        
        const obj = {
          competition: this.groupedMatches[cIndex].leagues[lIndex].competition,
          ...fullMatchDetails,
        };
        
        this.$store.commit("SET_MATCH", obj);
        this.$store.dispatch("GET_SAVED_COLOR");
        
      } catch (error) {
        console.error("Ошибка при загрузке деталей матча:", error);

        const status = error.response && error.response.status;

        if (status === 404) {
          // На сервере матча уже нет, а на экране он ещё есть: список успел устареть.
          // Молча перечитываем его, иначе человек тычет в мёртвую строку снова и снова
          await this.$store.dispatch("GET_SAVED_MATCHES_FROM_LOCAL_STORAGE");
          alert("Этого матча больше нет в сохранённых — список обновлён. Спарсите его заново.");
          return;
        }

        if (status === 400 || status === 401 || status === 403) {
          alert("Сессия истекла — залогиньтесь заново и повторите.");
          return;
        }

        alert("Не удалось загрузить подробную статистику матча.");
      }
    },
    // Строка обрезается многоточием — полный текст показываем подсказкой при наведении
    matchTitle(row) {
      const teams = `${row.teamAName} - ${row.teamBName}`;
      return row.seasonLabel ? `${teams} — ${row.seasonLabel}` : teams;
    },
    removeMatch(row) {
      // Вызываем правильный экшен из Vuex
      this.$store.dispatch("DELETE_SAVED_MATCH", row.id);
    },
    clearAllMatches() {
      // Вызываем наш новый экшен из Vuex
      this.$store.dispatch("CLEAR_ALL_SAVED_MATCHES");
      
      // Закрываем всё лишнее на экране
      this.openCountries = []; 
      this.openLeagues = [];
      this.showClearConfirm = false; 
    }
  },
  computed: {
    // 🌟 НОВАЯ ЛОГИКА ТРЕХУРОВНЕВОЙ ГРУППИРОВКИ
    groupedMatches() {
      const savedMatch = this.$store.getters.savedMatches;
      if (!savedMatch || Object.keys(savedMatch).length === 0) {
        return [];
      }

      const countriesMap = new Map();

      savedMatch.forEach((row) => {
        // 1. Определяем страну
        let finalCountry = "";
        if (row.competitionId && leagueIdToCountryMap[row.competitionId]) {
          finalCountry = leagueIdToCountryMap[row.competitionId];
        }
        if (!finalCountry) {
          finalCountry = row.countryName || row.country || (row.teamA && row.teamA.country) || (row.teamB && row.teamB.country) || "";
        }
        
        // 🔥 НОВЫЙ ФИЛЬТР: Если страна не нашлась, берем название самого турнира
        if (!finalCountry || finalCountry.trim() === "") {
          finalCountry = row.competition || "Другие турниры";
        }
        
        // 2. Если страны еще нет в карте, создаем
        if (!countriesMap.has(finalCountry)) {
          countriesMap.set(finalCountry, {
            country: finalCountry,
            leaguesMap: new Map()
          });
        }

        const countryObj = countriesMap.get(finalCountry);
        const uniqueLeagueKey = row.competitionId || row.competition;

        // 3. Если лиги еще нет внутри этой страны, создаем
        if (!countryObj.leaguesMap.has(uniqueLeagueKey)) {
          countryObj.leaguesMap.set(uniqueLeagueKey, {
            competition: row.competition,
            competitionId: row.competitionId, 
            matches: []
          });
        }

        // 4. Добавляем матч в нужную лигу
        countryObj.leaguesMap.get(uniqueLeagueKey).matches.push(row);
      });

      // Переводим из Map в обычные массивы и сортируем
      const result = Array.from(countriesMap.values()).map(cObj => {
        const leaguesArray = Array.from(cObj.leaguesMap.values());
        // Сортировка лиг внутри страны по алфавиту
        leaguesArray.sort((a, b) => (a.competition || "").localeCompare(b.competition || ""));
        
        return {
          country: cObj.country,
          leagues: leaguesArray
        };
      });

      // Сортировка самих стран по алфавиту
      result.sort((a, b) => {
        const countryA = a.country || "\uFFFF"; 
        const countryB = b.country || "\uFFFF";
        return countryA.localeCompare(countryB);
      });

      return result;
    },
  },
};
</script>

<style scoped lang="sass">
@import "../assets/vars"

.saved-matches-container
  position: relative
  display: flex
  flex-direction: column
  height: 100%

.saved-header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 12px 15px
  background-color: #f8f9fa
  border-bottom: 2px solid #ddd

.saved-title
  margin: 0
  font-size: 16px
  font-weight: 900
  color: #333
  text-transform: uppercase
  font-family: 'Arial', sans-serif

.clear-all-btn
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center
  padding: 6px
  border-radius: 4px
  transition: background-color 0.2s
  img
    height: 20px
  &:hover
    background-color: #ffdddd

.confirm-overlay
  position: absolute
  top: 50px 
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(255, 255, 255, 0.95)
  z-index: 100
  display: flex
  justify-content: flex-start
  align-items: center
  flex-direction: column
  padding-top: 50px

.confirm-box
  background: white
  padding: 20px
  border-radius: 8px
  box-shadow: 0 4px 15px rgba(0,0,0,0.15)
  text-align: center
  border: 1px solid #ddd
  width: 90%

.confirm-text
  font-size: 15px
  font-weight: bold
  color: #333
  margin-bottom: 20px

.confirm-actions
  display: flex
  justify-content: center
  gap: 15px

.btn-confirm
  padding: 8px 20px
  border: none
  border-radius: 4px
  cursor: pointer
  font-weight: bold
  font-size: 14px
  transition: transform 0.2s
  &.yes
    background-color: #dc3545
    color: white
  &.no
    background-color: #6c757d
    color: white
  &:hover
    transform: scale(1.05)

.fade-enter-active, .fade-leave-active
  transition: opacity 0.2s
.fade-enter, .fade-leave-to
  opacity: 0

.scroller
  height: calc(95vh - 50px) 
  overflow-y: auto
  overflow-x: hidden

/* 🌟 НОВЫЕ СТИЛИ ДЛЯ ИЕРАРХИИ 🌟 */

/* 1 Уровень: Страна */
.country-header
  padding: 10px 15px
  cursor: pointer
  user-select: none
  background-color: #f8f9fa 
  border-bottom: 1px solid #ddd
  transition: filter 0.2s 
  &:hover
    filter: brightness(0.95) 

.league-country-title
  font-size: 15px
  color: #333
  text-transform: uppercase
  letter-spacing: 0.5px
  font-weight: bold

/* 2 Уровень: Лига */
.league-header
  padding: 8px 15px 8px 25px /* Отступ слева для визуальной вложенности */
  background-color: #eef2f5 
  border-bottom: 1px solid #dee2e6
  cursor: pointer
  transition: background-color 0.2s
  &:hover
    background-color: #e2e7ec

.league-name
  font-weight: 700
  font-size: 14px
  color: #444

/* Стрелочки */
.arrow-icon
  font-size: 12px
  color: #444
  z-index: 2
  transition: transform 0.3s ease
  &.arrow-up
    transform: rotate(180deg)

.fade-slide-enter-active, .fade-slide-leave-active
  transition: all 0.3s ease
  max-height: 2000px
  overflow: hidden
.fade-slide-enter, .fade-slide-leave-to
  opacity: 0
  max-height: 0

/* 3 Уровень: Матчи */
.list-group-item
  height: 32px
  overflow: hidden
  padding: 0 10px 0 35px /* Еще больший отступ слева для матчей */
  display: flex
  justify-content: space-between
  align-items: center
  border-left: none
  border-right: none
  cursor: pointer
  transition: background-color 0.2s
  &:hover
    background-color: #e2e6ea
    .list-group-item-span
      color: #005f90

.list-group-item-span
  display: block
  overflow: hidden
  white-space: nowrap
  width: 90%
  text-overflow: ellipsis
  font-size: 14px
  font-weight: 650
  font-family: 'Arial', sans-serif
  transition: color 0.2s

.season-tag
  margin-left: 6px
  font-size: 12px
  font-weight: 500
  color: #6c757d

.remove
  display: flex
  align-items: center
  justify-content: center
  img
    height: 16px
    transition: all .2s ease-in-out
    &:hover
      transform: scale(1.2)

.card-body
  padding: 0
</style>